import { createReducer } from '@reduxjs/toolkit';

import {
  // generateOtpResponse,
  GenerateOtpResponse,
} from './post-generate-otp';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type OtpCoreMsReducerState = {
  generateOtpOkResponse?: GenerateOtpResponse;
};

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/
const initialState: OtpCoreMsReducerState = {
  generateOtpOkResponse: {} as GenerateOtpResponse,
};
/* -------------------------------------------------------------------------------------------------
 * reducer
 * -----------------------------------------------------------------------------------------------*/

const otpCoreMsReducer = createReducer(initialState, (builder) => {
  // builder.addCase(generateOtpResponse, (state, { payload }) => {
  //   state.generateOtpOkResponse = payload;
  //   return;
  // });
});

export default otpCoreMsReducer;
